"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitMap = void 0;
const UniqueEntityID_1 = require("../../core/domain/UniqueEntityID");
const Mapper_1 = require("../../core/infra/Mapper");
const Unit_1 = require("../domain/entities/Unit");
const GenericMap_1 = require("./GenericMap");
const TrackerMap_1 = require("../../core/mappers/TrackerMap");
const RemovedMap_1 = require("../../core/mappers/RemovedMap");
const SetupsMap_1 = require("./SetupsMap");
class UnitMap extends Mapper_1.Mapper {
    static toDomain(raw, ref, id, runValidation) {
        if (runValidation) {
            if (!Unit_1.Unit.validate(raw, ref, id).pass)
                return null;
        }
        const domainObject = !raw
            ? null
            : Unit_1.Unit.create({
                comment: raw.comment,
                description: raw.description,
                labels: raw.labels,
                name: raw.name,
                orgId: raw.orgId,
                removed: RemovedMap_1.RemovedMap.toDomain(raw.removed, ref),
                setting: SetupsMap_1.SetupsMap.toDomain(raw.setting, ref),
                tracker: TrackerMap_1.TrackerMap.toDomain(raw.tracker, ref),
                users: raw.users,
                usersCnt: raw.usersCnt,
                customData: raw.customData,
            }, ref, new UniqueEntityID_1.UniqueEntityID(id));
        return domainObject;
    }
    static toDTO(d) {
        const res = GenericMap_1.GenericMap.toDTO(d);
        // TODO add additional validation by schema
        return res;
    }
}
exports.UnitMap = UnitMap;
//# sourceMappingURL=UnitMap.js.map